const QUERY_PRIVACY_POLICY = '*[_type == "privacyPolicy"][0]';

export default QUERY_PRIVACY_POLICY;
